import { render } from "./InputSearchExam.vue?vue&type=template&id=4f9575e0&scoped=true"
import script from "./InputSearchExam.vue?vue&type=script&lang=js"
export * from "./InputSearchExam.vue?vue&type=script&lang=js"

import "./InputSearchExam.vue?vue&type=style&index=0&id=4f9575e0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9575e0"]])

export default __exports__